const lk = {
    LK_CLASS_STATUS_ID: {
        "SCHEDULED" : 1,
        "ACTIVE" : 2,
        "CANCELLED": 3,
        "HELD": 4,
        "PROCESSED": 5,
        "EXPIRED": 6
    },
    LK_USER_STATUS_ID: {
        "APPROVED": 1,
        "DECLINED": 2,
        "IN REVIEW": 3,
        "PENDING": 4
    },
    LK_USER_TYPE_ID: {
        "administrator": 1,
        "manager": 2,
        "affiliate": 3,
        "recruiter": 4,
        "instructor": 5,
        "student": 6 
    },
    LK_ADDRESS_TYPE_ID: {
        "user_address": 1,
        "student_address": 2,
        "billing_address": 3,
        "shipping_address": 4
    },
    LK_CLASS_APPROVAL_STATUS_ID: {
        "SUBMITTED": 1,
        "APPROVED": 2,
        "REJECTED": 3,
        "EXPIRED": 4,
        "RESUBMITTED": 5,
        "NOT SUBMITTED": 6,
        "COMPLETED": 7
      },
      LK_INSTRUCTOR_APPROVAL_STATUS_ID: {
        "SUBMITTED": 1,
        "APPROVED": 2,
        "REJECTED": 3,
        "EXPIRED": 4,
        "RESUBMITTED": 5,
        "NOT SUBMITTED": 6
      },
    LK_ORDER_STATUS_ID: {
        "Placed": 1,
        "Completed": 2,
        "Cancelled": 3,
        "Shipped": 4,
        "Unpaid": 5
    },
    PAYMENT_METHOD_ID: {
        "ADMIN_BYPASS": 1,
        "AUTHORIZENET_CREDIT_CARD" : 2,
        "AUTHORIZENET_PAYPAL": 3,
        "AUTHORIZENET_ACH_PAYMENT": 4,
        "MONEY_ORDER": 5
    }
}

export default lk